import { css, cx } from "@emotion/css";
import { ChevronDownIcon, ChevronRightIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { PropsWithChildren, ReactNode, SyntheticEvent } from "react";
import { useState } from "react";
type ManifestNavigationDetailsProps = PropsWithChildren<{
    summary: ReactNode;
    summaryClassName?: string;
}>;
const summaryStyles = css({
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    gap: space[4],
    color: themeTokens.color.text.primary,
    font: text.body.bold.medium,
    padding: space[8],
    listStyle: "none",
    "&::-webkit-details-marker": {
        display: "none",
    },
    "&::marker": {
        display: "none",
    },
});
const doNotShrink = css({
    flexShrink: 0,
});
export const ManifestNavigationDetails = (props: ManifestNavigationDetailsProps) => {
    const [open, setOpen] = useState(true);
    const handleToggle = (event: SyntheticEvent<HTMLElement, Event>) => {
        if (event.currentTarget instanceof HTMLDetailsElement) {
            setOpen(event.currentTarget.open);
        }
    };
    return (<details open={open} onToggle={(e) => handleToggle(e)}>
            <summary className={cx(summaryStyles, props.summaryClassName)}>
                <span className={doNotShrink}>{open ? <ChevronDownIcon size={16}/> : <ChevronRightIcon size={16}/>}</span>
                {props.summary}
            </summary>
            {props.children}
        </details>);
};
